import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Curriculum extends Model<Schemas['curricula'], Models> {
    get parentTagGroups() {
        return this.tagGroups?.filter((group) => group.isParent);
    }

    get requiredTagGroups() {
        const identifiers = this.relationships.tagGroups?.data || [];

        return identifiers
            .filter((identifier) => identifier.meta?.required)
            .map((identifier) => this.store.find(identifier) as Models['tagGroups'] | null)
            .filter((group) => group !== null);
    }
}
